import Editor from "../../../../src/components/LiveEditor/Editor";
import { SingleInstancePages } from "../../../../MDX/Decks/HOWTOGATSBY/CodeSnippets";
import Preload from "../../../../src/components/Presentations/Preload";
import * as React from 'react';
export default {
  Editor,
  SingleInstancePages,
  Preload,
  React
};